import { z } from 'zod';

import { listSearchSchema } from '@/shared/patterns/list-search';

import { billingSettingFilters } from './billing-setting.filters';

// `validateSearch` de /gestao-carteira/parametros (U07). Leve de propósito: é JS inicial.

/** Régua aberta no sheet (`?edit=<id>` ou `?edit=novo`, U26): o voltar fecha o sheet. */
const edit = z.string().min(1).max(64).optional().catch(undefined);

/** Página (a partir de 1), tamanho, os filtros do legado e a régua em edição. Sem ordenação (o legado não tem). */
export const billingSettingListSearch = listSearchSchema({ ...billingSettingFilters.shape, edit, sheet: z.string().min(1).max(40).optional().catch(undefined) });
export type BillingSettingListSearch = z.infer<typeof billingSettingListSearch>;
